export default {
  presenter: 'stransky',
  title: 'Mozek jsme my',
  subtitle: '',
  text: `
Přednáška známého neurologa z Yaleské univerzity objasní nezbytné základy pro získání odpovědí na otázky, jak se má učit a vychovávat. Veškerá výuka je totiž závislá na mozkových funkcích a
mechanismech.  Vědět, jak se mozek učí (a neučí) znamená rovněž vědět, jak učit (a neučit).  Přednáška se pokusí během (příliš) krátké doby alespoň trochu ozřejmit klíčové mozkové funkce a procesy vedoucí k učení a určení procesů rozhodování. Zároveň přesně ukáže, proč a jak jsou moderní technologie nebezpečné pro vývoj nejen mozku, ale celého lidstva.
  
Medicínu vystudoval v USA, dosud přednáší a je primářem neurologie v Yale University. Po revoluci založil Polikliniku na Národní v Praze, obnovil časopis Přítomnost, založil výměnné programy postgraduální výuky, nadace pro podporu občanské společnosti a Kancelář Ombudsmana pro zdraví pro ČR. Nyní se specializuje na neurofyziologickou funkci mozku, především v oblastech paměti a vědomí, prozkoumává základní vlivy lidského uvažování a technologie na lidský mozek, včetně jeho schopnosti vzdělávat se.
  `,
}



// WEBPACK FOOTER //
// ./src/content/devdata/data/presentations/p07_mozek_jsme_my.js